export default "__VITE_ASSET__BEPWwSMz__"